<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2025-03-06 09:48:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-06 11:00:14
-->
<template>
  <div class="course-container">
    <div class="course-sidebar">
      <el-card class="course-card">
        <div class="course-header">
          <h3 class="course-title">{{ formData.name }}</h3>
          <el-progress type="circle" :width="50" :percentage="formData.complation_rate" :stroke-width="5"
            color="#67C23A" class="progress-circle"></el-progress>
        </div>
        <p class="course-lessons">{{ formData.completion_lessons }}/{{ formData.total_lessons }} Lessons</p>

        <!-- 章节折叠列表 -->
        <el-collapse v-model="activeModules" class="module-collapse">
          <section-item v-for="section in formData.structure" :key="section.id" :progressData="progressData"
            :item="section" :depth="1" :activeModules="activeModules" @update:activeModules="updateActiveModules"
            @selectLesson="selectLesson" />
        </el-collapse>
      </el-card>
    </div>
    <!-- 右侧课程内容区域 -->
    <div class="course-content">

      <el-card class="lesson-card">
        <div class="lesson-title-box">
          <h3 class="lesson-title">{{ currentLesson.name }}</h3>
          <el-button v-if="currentLesson.id" type="primary" @click="restartLesson" :disabled="isLessonCompleted">
            {{ isLessonCompleted ? "completed" : "learn" }}
          </el-button>
        </div>
        <LessonPageContent ref="childLessonComponent"></LessonPageContent>
      </el-card>
    </div>
  </div>
</template>

<script>
import SectionItem from './SectionItem.vue';
import { customerCoursesParticulars, customerCoursesLearninRecords, customerCoursesLearninRecordsAdd } from "@/api/course";
import LessonPageContent from './components/LessonPageContent.vue'
export default {
  components: {
    'section-item': SectionItem,
    LessonPageContent
  },
  name: "CourseProgress",
  props: ['id'],
  data() {
    return {
      activeModules: [],
      currentLesson: {
        name: "Select a lesson to view details",
        description: "",
        image_url: null,
      },
      formData: {
      },
      progressData: [],
      courseId: ''
    };
  },
  created() {
    const id = this.$route.query.id;
    this.courseId = id
    this.customerCoursesParticularsApi(id)
    this.customerCoursesLearninRecordsApi(id)
  },
  computed: {
    // 判断当前课程是否已经学习完成
    isLessonCompleted() {
      return this.progressData.some(progress =>
        progress.lesson_id === this.currentLesson.id && progress.progress === 100
      );
    }
  },
  methods: {
    async customerCoursesLearninRecordsApi(id) {
      const res = await customerCoursesLearninRecords(id);
      this.progressData = res.body.items || []; // Ensure data is an array
    },

    async customerCoursesParticularsApi(id) {
      const res = await customerCoursesParticulars(id);
      console.log(res);
      this.formData = res.body;
    },

    selectLesson(lesson) {
      console.log(lesson);
      this.currentLesson = lesson;
      // Get lesson details
      this.$refs.childLessonComponent.getLessonDetail(this.courseId, lesson.id);
    },

    async restartLesson() {
      if (!this.currentLesson.id) {
        this.$message.error("Please select a lesson first");
        return;
      }

      const data = {
        lesson_id: this.currentLesson.id,
        progress: 100
      };

      try {
        const res = await customerCoursesLearninRecordsAdd(this.courseId || this.$route.query.id, data);
        if (res.success) {
          this.$message.success("Lesson completed successfully");
          this.progressData.push({
            lesson_id: this.currentLesson.id,
            progress: 100,
            updated_at: new Date().toISOString()
          });
        } else {
          this.$message.error("Submission failed, please try again later");
        }
      } catch (error) {
        // this.$message.error("Network error, please try again later");
        console.log('Network error');
        
      }
    },

    updateActiveModules(val) {
      this.activeModules = val;
    }
  }
};
</script>

<style scoped>
.course-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* 左侧课程进度 */
.course-sidebar {
  width: 300px;
}

.course-card {
  padding: 16px;
  text-align: center;
}

/* 右侧课程内容 */
.course-content {
  flex: 1;
}

.info-alert {
  margin-bottom: 20px;
}

.lesson-title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* .lesson-image {
  width: 100%;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 4px;
} */

.lesson-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.lesson-image,
.no-image-placeholder {
  width: 100%;
  height: 65vh;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.lesson-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-image-placeholder i {
  font-size: 50px;
  color: #c0c4cc;
}

.no-image-placeholder p {
  margin-top: 10px;
  color: #909399;
}
</style>